// extracted by mini-css-extract-plugin
export default {"container-table":"styles_container-table__ZLYGv","ApplicationsImpossible":"styles_ApplicationsImpossible__aNvK5"};